import values1 from '../assets/values1.png';
import values2 from '../assets/values2.png';
import values3 from '../assets/values3.png';
import values4 from '../assets/values4.png';
import values5 from '../assets/values5.png';
import values6 from '../assets/values6.png';
import values7 from '../assets/values7.png';

import unusualWayMobileBg from '../assets/the_unusual_way/mobile/bg.webp';
import unusualWayMobileExtendedBg from '../assets/the_unusual_way/mobile/extended_bg.webp';

export const ASSETS = {
    // Values
    valuesImg1: values1,
    valuesImg2: values2,
    valuesImg3: values3,
    valuesImg4: values4,
    valuesImg5: values5,
    valuesImg6: values6,
    valuesImg7: values7,

    // Unusual Way – mobile backgrounds (desktop uses SVG)
    unusualWayMobileBg,
    unusualWayMobileExtendedBg,

    // Site
    siteImg1:
        'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/ff8bc70e58d04a72bf174cb746a05a27-1783590771358/4.jpg',
    siteImg2:
        'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/ff8bc70e58d04a72bf174cb746a05a27-1783590771379/5.jpg',
    siteImg3:
        'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a8c5b83bbaf3ae6c9d9d19cfc9ad219e-1783590856109/3.jpg',
    siteImg4:
        'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/ff8bc70e58d04a72bf174cb746a05a27-1783590771372/1.jpg',
    siteImg5:
        'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a8c5b83bbaf3ae6c9d9d19cfc9ad219e-1783590856112/2.jpg',
    siteImg6:
        'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/ff8bc70e58d04a72bf174cb746a05a27-1783590771375/6.jpg',
    siteImg7:
        'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/ff8bc70e58d04a72bf174cb746a05a27-1783590771375/8.jpg',
    siteImg8:
        'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a8c5b83bbaf3ae6c9d9d19cfc9ad219e-1783590856133/7.jpg',
};
